import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { RegisterRequest } from 'src/app/core/_models/register-request';
import { AccountService } from 'src/app/core/_services/account.service';
import { DialogRegisterRequestComponent } from '../shared/dialog-register-request/dialog-register-request.component';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.scss']
})
export class AdministrationComponent implements OnInit {
  pendingRequests: RegisterRequest[] = [];
  loading = false;

  constructor(
    private accountService: AccountService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.loadPendingRequests();
  }

  loadPendingRequests(): void {
    this.loading = true;
    this.accountService.getRegisterRequests().subscribe({
      next: (requests) => {
        this.pendingRequests = requests ?? [];
        this.loading = false;
      },
      error: () => {
        this.pendingRequests = [];
        this.loading = false;
        this.snackBar.open(this.translate.instant('snackbar_error'), '', { duration: 3000 });
      }
    });
  }

  profileLabel(code: string): string {
    if (!code) {
      return '';
    }
    const key = `validation_profile_${code}`;
    const label = this.translate.instant(key);
    return label === key ? code : label;
  }

  openDetail(request: RegisterRequest): void {
    const dialogRef = this.dialog.open(DialogRegisterRequestComponent, {
      data: request,
      width: '600px',
      maxWidth: '94vw',
      panelClass: 'register-detail-panel',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'accept') {
        this.resolveRequest(request, this.accountService.validateRegisterRequest(request.id!), 'validation_toast_accepted');
        return;
      }
      if (result === 'refuse') {
        this.resolveRequest(request, this.accountService.refuseRegisterRequest(request.id!), 'validation_toast_refused');
      }
    });
  }

  private resolveRequest(request: RegisterRequest, decision: Observable<Object>, toastKey: string): void {
    decision.subscribe({
      next: () => {
        this.pendingRequests = this.pendingRequests.filter((item) => item !== request);
        const message = this.translate.instant(toastKey, { name: `${request.prenom} ${request.nom}` });
        this.snackBar.open(message, '', { duration: 3000 });
      },
      error: () => this.snackBar.open(this.translate.instant('snackbar_error'), '', { duration: 3000 })
    });
  }
}
